import axiosClient from '../axiosClient';
import { PackPickEndpoints } from '../endpoints/packPick';
import {
  IStatusQueuesResponse,
  IPackingStation,
  IPackingOrderDetail,
  IGetPackedOrdersResponse,
  IPackedOrderHistoryEntry,
  IOrderPackage,
} from '../../types/api/response/packpickresponse';
import {
  IStartPackRequest,
  ICompletePackRequest,
  ICancelPackRequest,
} from '../../types/api/request/packpickrequest';

export const PackPickService = {
  async getStatusQueues(): Promise<IStatusQueuesResponse> {
    const res = await axiosClient.get<IStatusQueuesResponse>(PackPickEndpoints.GET_STATUS_QUEUES);
    return res.data;
  },

  async getStations(): Promise<IPackingStation[]> {
    const res = await axiosClient.get<IPackingStation[]>(PackPickEndpoints.GET_STATIONS);
    return res.data;
  },

  async getOrderDetails(orderNo: string): Promise<IPackingOrderDetail> {
    const res = await axiosClient.get<IPackingOrderDetail>(
      PackPickEndpoints.GET_ORDER_DETAILS(orderNo),
    );
    return res.data;
  },

  async startPick(orderNo: string): Promise<void> {
    await axiosClient.post(PackPickEndpoints.START_PICK(orderNo));
  },

  async startPack(orderNo: string, body: IStartPackRequest): Promise<void> {
    await axiosClient.post(PackPickEndpoints.START_PACK(orderNo), body);
  },

  async completePack(orderNo: string, body: ICompletePackRequest): Promise<void> {
    await axiosClient.post(PackPickEndpoints.COMPLETE_PACK(orderNo), body);
  },

  async cancelPack(orderNo: string, body: ICancelPackRequest): Promise<void> {
    await axiosClient.post(PackPickEndpoints.CANCEL_PACK(orderNo), body);
  },

  async getPackedOrders(
    page: number = 0,
    size: number = 20,
    search?: string,
    status?: string,
  ): Promise<IGetPackedOrdersResponse> {
    const res = await axiosClient.get<IGetPackedOrdersResponse>(
      PackPickEndpoints.GET_PACKED_ORDERS,
      {
        params: { page, size, ...(search ? { search } : {}), ...(status ? { status } : {}) },
      },
    );
    return res.data;
  },

  async getPackedOrderHistory(orderNo: string): Promise<IPackedOrderHistoryEntry[]> {
    const res = await axiosClient.get<IPackedOrderHistoryEntry[]>(
      PackPickEndpoints.GET_PACKED_ORDER_HISTORY(orderNo),
    );
    return res.data;
  },

  async getPackedOrderPackages(orderNo: string): Promise<IOrderPackage[]> {
    const res = await axiosClient.get<IOrderPackage[]>(
      PackPickEndpoints.GET_PACKED_ORDER_PACKAGES(orderNo),
    );
    return res.data;
  },
};
